import styled from 'styled-components';

export const StyledPartners = styled.section`
    padding: 200px 0 170px;
    position: relative;
    background: #FFFFFF;
    overflow: hidden;
    @media (max-width: 767px) {
        padding: 120px 0 90px !important;

    }
	.swiper-pagination-bullet{
		&.swiper-pagination-bullet-active{
			background-color: #DD223F;
		}
	}
    .swiper-pagination{
		position: absolute;
		bottom: -5px !important;
	}
    .swiper{
        padding-bottom: 30px;
    }
    .col-md-2{
        min-height: 120px;
    }
    .fix-left {
        position: absolute;
        bottom: 100px;
        right: 0;
        z-index: -1;

        h3 {
            color: rgba(21, 38, 55, 0.03);
            @media (max-width: 767px) {
                font-weight: 500 !important;
                font-size: 7.5rem !important;           /* 120px ÷ 16 */
                line-height: 100% !important;           /* same as font-size */
                letter-spacing: -0.05em !important;     /* -5% of current font-size */
            }
        }
    }

    .fix-right {
        position: absolute;
        top: 100px;
        left: 0;
        z-index: -1;

        h3 {
            color: rgba(21, 38, 55, 0.03);
            @media (max-width: 767px) {
                font-weight: 500 !important;
                font-size: 7.5rem !important;           /* 120px ÷ 16 */
                line-height: 100% !important;           /* same as font-size */
                letter-spacing: -0.05em !important;     /* -5% of current font-size */
            }
        }
    }

    .subtitle-ygen {
        color: #15263780;
        @media (max-width: 767px) {
            margin-bottom: 40px;
        }
    }

    .award-single {
        margin-bottom: 30px;

    }

    .single-partners-image {
        position: relative;
        padding-top: calc(120 / 170 * 100%);
        //margin-bottom: 30px;
        display: flex;
        align-items: center;
        justify-content: center;
        opacity: 0;
        overflow: hidden;
        border-radius: 8px;
        background: linear-gradient(145deg, #f8f9fa, #ffffff);
        box-shadow: 0 4px 15px rgba(21, 38, 55, 0.08);
        transition: box-shadow 0.3s ease;

        &:hover {
            box-shadow: 0 8px 25px rgba(21, 38, 55, 0.15);
        }

        .image-overlay {
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            background: linear-gradient(135deg, #152637 0%, #1a3245 50%, #152637 100%);
            z-index: 2;
            transform-origin: left center;
        }

        .image-wrapper {
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
            width: 80%;
            height: 80%;
            display: flex;
            align-items: center;
            justify-content: center;
            z-index: 1;
        }

        img {
            width: auto;
            height: auto;
            object-fit: contain;
            max-width: 100%;
            max-height: 100%;
            transition: transform 0.3s ease;

            &:hover {
                transform: scale(1.05);
            }
        }

        // Add a subtle glow effect
        &::before {
            content: '';
            position: absolute;
            top: -2px;
            left: -2px;
            right: -2px;
            bottom: -2px;
            background: linear-gradient(45deg, transparent, rgba(221, 34, 63, 0.1), transparent);
            border-radius: 10px;
            z-index: -1;
            opacity: 0;
            transition: opacity 0.3s ease;
        }

        &:hover::before {
            opacity: 1;
        }
    }


    @media (max-width: 767px) {
        .col-md-2, .col-md-3 {
            max-width: 50%;
            width: 50%;
            flex: 0 0 50%
        }
      
		
    }

`;
